export default {
  sectors: (state) => state.sectors,
  sectorList: (state) => state.sectorList,
  agencies: (state) => state.agencies,
  agencyList: (state) => state.agencyList,
  currentSector: (state) => state.currentSector,
  currentAgency: (state) => state.currentAgency,
  isLoading: (state) => state.loading,
  instanceId: (state) => state.instanceId,
  isFormBackendValidated: (state) => state.isFormBackendValidated,
  editingAgencyVaccineException: (state) => state.editingAgencyVaccineException,
};
